import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Grid, Typography } from '@mui/material'

import { COMPONENT_EXTENDER } from 'extender'

import { useStyles } from './styles'

const SingleContainerLayoutComponent = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')

const ErrorServer404 = () => {
    const { classes } = useStyles({ errorCode: 404 })
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <SingleContainerLayoutComponent disableGoBack>
            <Box className={classes.errorContainer} data-sta-id="error-404">
                <Grid container className="errorWrap">
                    <Grid item sm={12} md={5} className="img" />
                    <Grid item sm={12} md={7} className="card">
                        <div className="content">
                            <Typography className="title">{t('ErrorBoundary.ErrorServer404.Title')}</Typography>
                            <Typography>{t('ErrorBoundary.ErrorServer404.ErrorMsg')}</Typography>
                            <Button type="button" className="button" variant="contained" color="primary" onClick={() => navigate('/')}>
                                {t('ErrorBoundary.ErrorServer404.BackButton')}
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </SingleContainerLayoutComponent>
    )
}

export default ErrorServer404

